import "./style.scss";

import { Col, Hr, Row, Spacer, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { TrafficFrom } from "common/helpers/traffic-from";
import { SearchResultProps } from "common/types";
import { getString } from "common/uistringlabels/uiStringUtils";
import NoLogoImage from "img/no_logo_image.png";
import { ItemTaxonomyId } from "lib/taxonomy/item-taxonomy-id";
import React, { FC } from "react";
import { useHistory } from "react-router-dom";

import { SearchResultV2 } from "../SearchResultV2";

export const SearchResult: FC<SearchResultProps> = (props: SearchResultProps) => {
  const history = useHistory();
  let detailsUrl = "#";

  if (props.useSearchExperience) {
    return <SearchResultV2 {...props} />;
  } else {
    // Since some catalog items will not have a strain value, parsing the taxonomy
    // could throw an error, handling this with a try/catch in the meantime
    try {
      detailsUrl = `items/${ItemTaxonomyId.Parse(props.taxonomyId!).getUrlSuffix()}?from=${TrafficFrom.Search}`;
    } catch (error) {
      // TODO: report this error to cloudwatch. (To be resolved by ITMP-344)
    }

    /* istanbul ignore next */
    const onSearchResultClick = (event: any) => {
      if (detailsUrl !== "#") {
        if (event.ctrlKey) return true; // allows a new tab if ctrl + click

        history.push(detailsUrl);
        event.preventDefault();
      }
    };

    return (
      <a href={detailsUrl} style={{ textDecoration: "none" }} data-cy="catalog-result-link">
        <View className={`catalog-result-view catalog-item`}>
          <Col gridGap={"0px"}>
            {/* Result */}
            <View padding={{ top: "20px", bottom: "20px" }} style={{ cursor: "pointer" }} onClick={onSearchResultClick}>
              <Col gridGap={"S200"}>
                {/* Img and description */}
                <Row gridGap={"S300"}>
                  {/* Shadow */}
                  <View
                    display="flex"
                    height={"78px"}
                    padding={"S100"}
                    alignItems="flex-start"
                    className="img-square-wrapper"
                    style={{ borderRadius: "16px" }}
                  >
                    {/* Logo image */}
                    <img
                      alt={props.name}
                      src={props.logoUrl.trim() !== "" ? props.logoUrl : NoLogoImage}
                      data-testid="catalog-item-url"
                      data-details-logo="details-logo"
                      style={{
                        borderRadius: "16px",
                        width: "70px",
                        height: "70px",
                        objectFit: "contain",
                      }}
                    />
                  </View>

                  {/* Title and description */}
                  <Col gridGap={"S200"} data-testid="search-result-text">
                    <Text
                      fontSize="T200"
                      fontWeight="bold"
                      color="neutral90"
                      lineHeight="24px"
                      dataTestId="catalog-result-name"
                    >
                      {props.name}
                    </Text>
                    <Text
                      fontSize="T200"
                      fontWeight="regular"
                      color="neutral90"
                      lineHeight="24px"
                      dataTestId="catalog-result-short-description"
                    >
                      {props.shortDescription}
                    </Text>
                  </Col>
                </Row>

                {/* Multiple options */}
                {props.showMultipleOptions && (
                  <Row gridGap={"S300"}>
                    <Spacer width={80} />
                    <Text fontSize={"T100"} fontWeight={"regular"} color="neutral70" lineHeight={"22px"}>
                      {getString(`searchResult.multipleOptions`)}
                    </Text>
                  </Row>
                )}
              </Col>
            </View>

            {/* Divider */}
            <Hr />
          </Col>
        </View>
      </a>
    );
  }
};
